const normalizeCity = (value = "") =>
  String(value)
    .trim()
    .toLocaleLowerCase("tr-TR")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

export const isTurkeyAdminScope = (user) => {
  const normalizedCity = normalizeCity(user?.city);
  return user?.role === "admin" && ["turkiye", "turkey"].includes(normalizedCity);
};

export const buildScopedPath = (basePath, { user, city, query = "" } = {}) => {
  if (isTurkeyAdminScope(user)) {
    return `${basePath}${query}`;
  }

  if (!city) {
    return `${basePath}${query}`;
  }

  return `${basePath}/by-city/${encodeURIComponent(city)}${query}`;
};

/**
 * FormData'ya il alanlarını yazar.
 *
 * FormData her değeri METNE çevirir: alana konan null/undefined sunucuya
 * "null" / "undefined" metni olarak ulaşır. Oturumda city_id bilgisi hiç
 * bulunmadığı için takım/oyuncu ekleme formları her seferinde city_id="null"
 * gönderiyordu; sunucudaki il bekçisi bunu "başka bir il seçilmiş" sayıp il
 * yetkilisine kendi ilinde bile "Yalnızca kendi iliniz için kayıt
 * oluşturabilirsiniz." hatası döndürüyordu.
 *
 * Bu yüzden yalnızca gerçek değerler eklenir. Alan hiç gönderilmediğinde
 * sunucu kaydı zaten kullanıcının kendi iline yazar.
 */
export const appendCityFields = (formData, { city, cityId } = {}) => {
  const cityName = typeof city === "string" ? city.trim() : city;
  if (cityName) formData.append("city", cityName);

  const parsedCityId = Number(cityId);
  if (cityId !== null && cityId !== undefined && cityId !== "" && Number.isFinite(parsedCityId)) {
    formData.append("city_id", String(parsedCityId));
  }

  return formData;
};
